import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import React from 'react';

import { UserDetailsFieldProps } from '../models';
import * as styles from './user-details-section.module.scss';

export const UserDetailsField = ({
  label,
  defaultValue,
}: UserDetailsFieldProps) => {
  const getContent = () => {
    if (Array.isArray(defaultValue)) {
      return defaultValue?.join(', ');
    }

    return defaultValue;
  };

  return (
    <div className={classNames(styles.item, 'auth-profile-section__item')}>
      {label && (
        <Typography
          variant="body"
          tag="span"
          size="m"
          weight="medium"
          className={classNames(styles.label, 'auth-profile-section__label')}
          content={label}
        />
      )}
      <Typography
        variant="body"
        tag="span"
        size="m"
        weight="regular"
        className={classNames(styles.value, 'auth-profile-section__value')}
        content={getContent() || '-'}
        title={getContent()}
      />
    </div>
  );
};
